import useSWRImmutable from "swr/immutable";

import { getFeatureFlag } from "../../constants/featureFlags";

import type { FeatureFlag } from "../../constants/featureFlags";

const MMS_FOR_VOD_KEY = "MMSForVOD";

const getMMSForVODFeatureFlag = async (): Promise<FeatureFlag | undefined> => {
  return await getFeatureFlag(MMS_FOR_VOD_KEY);
};

export const useEnableMMSForVOD = (
  eventId: string | undefined
): boolean | undefined => {
  const { data: mmsForVODFeatureFlag } = useSWRImmutable<FeatureFlag>(
    "getMMSForVODFeatureFlag",
    async () => {
      let flag: FeatureFlag | undefined;
      try {
        flag = await getMMSForVODFeatureFlag();
      } catch (error) {
        console.debug("Failed to fetch signedUrl feature flag:", error);
        return {
          globalEnabled: false,
          events: {},
        };
      }
      if (flag === undefined) {
        return {
          globalEnabled: false,
          events: {},
        };
      }
      return flag;
    }
  );

  try {
    // From search params
    const params = new URLSearchParams(window.location.search);
    if (params.get(MMS_FOR_VOD_KEY) === "1") {
      return true;
    }

    // loading
    if (mmsForVODFeatureFlag === undefined) {
      return undefined;
    }

    if (mmsForVODFeatureFlag.globalEnabled) {
      return true;
    }
    if (eventId && mmsForVODFeatureFlag.events[eventId]) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};
